<template lang='pug'>
//- iframe(:src='info.detailLink')
systemSite(v-if='info.detailLink' :link="info.detailLink")
</template>

<script>
import { getDataRow, getPathNames } from '@custouch/proxy-use'
import systemSite from '@/views/components/systemSite.vue'
export default {
    // props: ['title', 'name'],
    props: ['rId', 'hId'],
    data() {
        return {
            info: {}
        }
    },
    components: {
        systemSite
    },
    async created() {
        const ret = await getDataRow({dataRowId: this.rId})
        let title = ret.detail.name
        if(this.hId){
            title = await getPathNames(this.hId,ret.detail.name)
        }
        this.info = ret.detail
        this.$root.$emit('pageview',{
            title,
            tagIds: ret.tagIds.join(',')
        })
        // const list = await this.$store.dispatch('getJson', window.env.VUE_APP_DATA_MARKET_NEWS)
        // this.info = list.find(item => item.name === this.name)
    }
}
</script>

<style scoped lang='less'>
iframe{
    width: 100%;
    border: 0;
}
</style>